import { CloseButton } from '@slot-nx/core'
import { betDetailService } from '../../domain/betDetail/service/BetDetailService'
import { memo } from 'react'

interface BetDetailCloseButtonProps {
  isFromOpBetDetail: boolean
}
export const BetDetailCloseButton = memo((props: BetDetailCloseButtonProps) => {
  if (props.isFromOpBetDetail) return null
  return (
    <CloseButton
      x={990}
      y={30}
      width={60}
      height={60}
      onPress={() => {
        betDetailService.resetDetailData()
      }}
    />
  )
})
